import { gql } from '@apollo/client';

export const START_ANPR_PARKING = gql`
  mutation createANPRParkingSession($input: CreateANPRParkingSessionInput!) {
    createANPRParkingSession(input: $input) {
      sessionId
    }
  }
`;
